import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import Naver, { EfProductNaverItemProps, EfProductNaverProps } from '@elem/ui/ef-product-naver';
import { useEffect, useState } from 'react';
import { IPageStatus } from './config/IPageStatus';
import { theme } from './config/page';
import getProductMsg from './context/getProduct';
import css from './index.module.scss';
import { useProduct, useProductPageStatus } from './ProductProvider';
import Bundle from './tabs/Bundle';
import Overview from './tabs/Overview';
import Spec from './tabs/Spec';
import Support from './tabs/Support';

const ATS: React.FC = () => {
    const { state, dispatch } = useProduct();
    const { t } = useLang('ats');
    const { productMsg, productSupport, productSpecs, activeTab } = state;
    const [activetedTabs, setActivetedTabs] = useState<string[]>([activeTab]);
    const { locale = 'us' } = getLocal();
    const pageStatus = useProductPageStatus();

    const naverProps: EfProductNaverProps = {
        theme: 'black',
        title: productMsg?.name || t('naver_title'),
        tabs: [
            {
                key: 'Product',
                text: t('naver_tab_product'),
            },
            locale !== 'ca' && {
                key: 'Bundle',
                text: t('naver_tab_bundles'),
            },
            {
                key: 'Spec',
                text: t('naver_tab_spec'),
            },
            {
                key: 'Support',
                text: t('naver_tab_support'),
            },
            // {
            //     key: 'early',
            //     text: t('naver_tab_early'),
            // },
        ].filter(Boolean) as EfProductNaverItemProps[],
        buyItem: {
            key: 'Bundle',
            text: locale === 'us' ? (pageStatus === IPageStatus.EARLY ? t('naver_tab_early') : t('naver_tab_buy')) : t('naver_tab_buy'),
        },
        activeTab,
        buyNowGtm: {
            event: 'uaEvent',
            event_name: 'product_navigation',
            navigation_name: locale === 'us' ? (pageStatus === IPageStatus.EARLY ? t('naver_tab_early') : t('naver_tab_buy')) : t('naver_tab_buy'),
            product_name: productMsg?.name || t('naver_title'),
            __btn_id1: 'ef-product-naver-buy',
            __btn_id2: 'naver-tab-buy',
            __btn_type: 'common',
        },
        callbackBuy: () => {
            if (!activetedTabs.includes('Bundle')) {
                setActivetedTabs([...activetedTabs, 'Bundle']);
            }
            dispatch({
                type: 'changeProductTab',
                payload: 'Bundle',
            });
            window.scrollTo({
                top: 0,
                behavior: 'instant',
            });
        },
        callbackTab: (tab: EfProductNaverItemProps) => {
            if (tab.key !== activeTab) {
                if (tab.key === 'early') {
                    // window.open('', '_blank');
                } else {
                    if (!activetedTabs.includes(tab.key)) {
                        setActivetedTabs([...activetedTabs, tab.key]);
                    }
                    dispatch({
                        type: 'changeProductTab',
                        payload: tab.key,
                    });
                    window.scrollTo({
                        top: 0,
                        behavior: 'instant',
                    });
                }
            }
        },
    };
    /** 检测浏览器是否支持使用 webp */
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const webP = new Image();
        webP.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
        webP.onload = () => {
            dispatch({
                type: 'changeCanWebp',
                payload: 1,
            });
        };
        webP.onerror = () => {
            dispatch({
                type: 'changeCanWebp',
                payload: -1,
            });
        };
    }, [dispatch]);

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const loadPageBaseGtm = () => {
    //             const searchEntry: any = localStorage.getItem('search_entry');

    //             gtm.push({
    //                 event: 'uaEvent',
    //                 event_name: 'product_page_load',
    //                 source_method: searchEntry || 'Non Source Method',
    //             });
    //         };
    //         window.addEventListener('load', loadPageBaseGtm);
    //         return () => {
    //             window.removeEventListener('load', loadPageBaseGtm);
    //         };
    //     }
    // }, []);

    return (
        <>
            {!productMsg && getProductMsg()}
            <div className={`stream-ultra-x ${css.section}`} style={{ minHeight: '100vh' }}>
                <Naver {...naverProps} />
                {activetedTabs.includes('Product') && (
                    <div className="page-tab tab-overview" style={{ display: activeTab === 'Product' ? 'block' : 'none' }}>
                        <Overview />
                    </div>
                )}
                {activetedTabs.includes('Bundle') && (
                    <div className="page-tab tab-Spec" style={{ display: activeTab === 'Bundle' ? 'block' : 'none' }}>
                        <Bundle />
                    </div>
                )}
                {activetedTabs.includes('Spec') && (
                    <div className="page-tab tab-Spec" style={{ display: activeTab === 'Spec' ? 'block' : 'none' }}>
                        <Spec productSpecs={productSpecs} theme={theme} />
                    </div>
                )}
                {activetedTabs.includes('Support') && (
                    <div className="page-tab tab-support" style={{ display: activeTab === 'Support' ? 'block' : 'none' }}>
                        <Support supportData={productSupport} productMsg={productMsg} theme={theme} />
                    </div>
                )}
            </div>
        </>
    );
};

export default ATS;
